import React from 'react';
import { Star } from 'lucide-react';
interface T {
  initials: string;
  name: string;
  role: string;
  country: string;
  text: string;
}
const Card = ({
  initials,
  name,
  role,
  country,
  text
}: T) => <div className="brunson-card rounded-lg p-4 md:p-5 flex flex-col h-full" data-id="element-250">
    <div className="flex text-brand-orange mb-2" data-id="element-251">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-252" />)}
    </div>
    <p className="text-sm md:text-base text-brand-ink italic leading-relaxed font-medium flex-grow" data-id="element-253">
      "{text}"
    </p>
    <div className="flex items-center gap-3 mt-3 pt-3 border-t border-brand-line" data-id="element-254">
      <div className="w-11 h-11 rounded-full bg-brand-navy text-white font-display font-bold flex items-center justify-center shrink-0" data-id="element-255">
        {initials}
      </div>
      <div data-id="element-256">
        <p className="font-display font-bold text-brand-navy text-sm uppercase leading-tight" data-id="element-257">
          {name}
        </p>
        <p className="text-xs text-brand-mute font-medium" data-id="element-258">
          {role} · {country}
        </p>
      </div>
    </div>
  </div>;
export function Testimonials() {
  const items: T[] = [{
    initials: 'RM',
    name: 'Ing. Roberto Méndez',
    role: 'Docente de Producción Acuícola',
    country: 'Colombia',
    text: 'Antes de Acuicultura Pro, pasaba mis vacaciones diseñando el curso. Ahora abro la Planificación del Bono 4, la ajusto en 20 minutos y listo. Mis alumnos aprenden más y yo duermo mejor.'
  }, {
    initials: 'LE',
    name: 'Profa. Lucía Espinoza',
    role: 'Capacitadora Técnica',
    country: 'Ecuador',
    text: 'El Tomo 5 de Sanidad le cambió la vida a mis alumnos en el campo. Por primera vez entienden por qué se mueren los peces y cómo prevenirlo. El protocolo de necropsia lo hicimos con una tilapia del mercado. Fue épico.'
  }, {
    initials: 'MT',
    name: 'Téc. Marcos Tincopa',
    role: 'Instructor de Campo',
    country: 'Perú',
    text: 'El material del Tomo 3 sobre trucha es el mejor que he visto en 15 años en el sector. Habla exactamente de lo que viven cada día en el campo.'
  }, {
    initials: 'SP',
    name: 'Profa. Sandra Paredes',
    role: 'Escuela Agropecuaria',
    country: 'Colombia',
    text: 'Mis colegas me preguntan qué curso hice. Les digo que no fue un curso — fue un sistema. Y el sistema trabaja por vos.'
  }, {
    initials: 'DH',
    name: 'Prof. Diego Hernández',
    role: 'Instituto Tecnológico Pesquero',
    country: 'Ecuador',
    text: 'Las rúbricas del Bono 2 me salvaron. Ya no discuto con los alumnos sobre las notas. Todo está explicado, criterio por criterio.'
  }];
  return <section className="py-8 px-4 bg-brand-creamAlt border-y-2 border-brand-line" data-id="element-259">
      <div className="max-w-6xl mx-auto" data-id="element-260">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase mb-6 leading-tight" data-id="element-261">
          Lo que dicen los <span className="green-highlight" data-id="element-262">docentes:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-263">
          {items.map((t, i) => <Card key={i} {...t} data-id="element-264" />)}
        </div>
      </div>
    </section>;
}